import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/message/style/css';
import "core-js/modules/es.array.push.js";
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { getCurrentInstance, reactive, ref, watch } from 'vue';
import apis from "@/api";
import _ from 'lodash';
import { genFileId } from 'element-plus';
export default {
  __name: 'Upload',
  props: {
    fileTypes: {
      type: Array,
      default: () => {
        return ['image/jpeg', 'image/png', 'image/gif'];
      },
      required: false
    },
    fileSize: {
      type: Number,
      default: 10,
      //单位MB
      required: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    vaildImgType: {
      type: Boolean,
      default: false
    },
    btnText: {
      type: String,
      default: "上传文件"
    }
  },
  emits: ['fileChange'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const {
      proxy
    } = getCurrentInstance();
    const props = __props;
    const emits = __emit;
    const data = reactive({
      fileList: []
    });
    const fileLoading = ref(false);

    // const submitUpload = () => {
    //   if (!data.fileList || data.fileList.length == 0) {
    //     ElMessage.error('请先选取文件')
    //     return
    //   }
    //   fileLoading.value = true
    //   let formData = new FormData()
    //   data.fileList.forEach(f => {
    //     formData.append('fileList', f)
    //   })
    //   apis.upload(formData).then((res) => {
    //     console.log("upload-res: ", res);
    //     if (res && res.success) {
    //       emits('uploadSuccess', res.data)
    //     } else {
    //       ElMessage.error('文件上传失败:' + res.msg)
    //     }
    //     fileLoading.value = false
    //   }).catch((err) => {
    //     console.log("err", err)
    //     ElMessage.error('文件上传失败')
    //     fileLoading.value = false
    //   })
    // }

    const uploadFiles = params => {
      data.fileList.push(params.file);
    };
    const handleExceed = params => {
      data.fileList = [];
      params[0].uid = genFileId();
      data.fileList.push(params[0]);
    };
    const handleRemove = (file, fileList) => {
      let tempFileList = [];
      for (var index = 0; index < data.fileList.length; index++) {
        if (data.fileList[index].name !== file.name) {
          tempFileList.push(data.fileList[index]);
        }
      }
      data.fileList = tempFileList;
    };
    const beforeUpload = rawFile => {
      if (props.vaildImgType) {
        const index = _.findIndex(props.fileTypes, type => {
          return type === rawFile.type;
        });
        if (index === -1) {
          ElMessage.error('文件类型不支持:' + rawFile.type);
          return false;
        }
        if (rawFile.size / 1024 / 1024 > props.fileSize) {
          ElMessage.error('文件大小超出限制');
          return false;
        }
      }
      return true;
    };
    watch(() => data.fileList, (newvalue, oldvalue) => {
      emits('fileChange', newvalue);
    }, {
      deep: true,
      immediate: true
    });
    const clearFile = () => {
      console.info('clearFile ···');
      data.fileList = [];
    };
    __expose({
      clearFile
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_upload = _resolveComponent("el-upload");
      return _openBlock(), _createBlock(_component_el_upload, {
        multiple: __props.multiple,
        "http-request": uploadFiles,
        "file-list": data.fileList,
        "before-upload": beforeUpload,
        "on-exceed": handleExceed,
        "on-remove": handleRemove
      }, {
        trigger: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(props.btnText), 1)]),
          _: 1
        })]),
        _: 1
      }, 8, ["multiple", "file-list"]);
    };
  }
};